const activityStatusTranslate: Record<string, string> = {
  'STATUS.SCHEDULED': 'Agendada',
  'STATUS.COMPLETED': 'Completada',
  'STATUS.CANCELLED': 'Cancelada',
}

export default activityStatusTranslate
export const transActivityStatus = (status: string | undefined) => {
  if (!status) {
    status = 'STATUS.SCHEDULED'
  }

  return activityStatusTranslate[status]
}
